import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { KeyRound, ChevronLeft } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) { toast.error("Minimal 6 karakter"); return; }
    if (pwd !== pwd2) { toast.error("Konfirmasi kata sandi tidak cocok"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Kata sandi berhasil direset. Silakan login.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal reset kata sandi");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-paper to-terra-50/30 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs uppercase tracking-wider text-stone-500 hover:text-terra-700 mb-4">
          <ChevronLeft className="h-3 w-3" /> Login
        </Link>
        <div className="bg-white border border-stone-200 shadow-sm p-6 md:p-8">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-terra-700 mb-1">
            <KeyRound className="h-3 w-3" /> Reset Kata Sandi
          </div>
          <h1 className="font-display text-2xl font-bold text-stone-900">Buat Kata Sandi Baru</h1>
          {!token ? (
            <p className="text-sm text-red-700 mt-4">Tautan reset tidak valid (token kosong).</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="block text-[11px] uppercase tracking-wider text-stone-600 font-semibold mb-1">Kata Sandi Baru</label>
                <input type="password" required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)}
                  className="w-full border border-stone-300 px-3 py-2.5 text-sm focus:border-terra-500 focus:outline-1 focus:outline-terra-500"
                  data-testid="reset-pwd1" />
              </div>
              <div>
                <label className="block text-[11px] uppercase tracking-wider text-stone-600 font-semibold mb-1">Konfirmasi Kata Sandi</label>
                <input type="password" required minLength={6} value={pwd2} onChange={(e) => setPwd2(e.target.value)}
                  className="w-full border border-stone-300 px-3 py-2.5 text-sm focus:border-terra-500 focus:outline-1 focus:outline-terra-500"
                  data-testid="reset-pwd2" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-terra-500 hover:bg-terra-600 text-white py-2.5 text-sm font-medium disabled:opacity-60" data-testid="reset-submit">
                {loading ? "Memproses…" : "Reset Kata Sandi"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
